// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_rh-0";